import { render, staticRenderFns } from "./SaldoDeIndicacao.vue?vue&type=template&id=05c8579b"
import script from "./SaldoDeIndicacao.vue?vue&type=script&lang=js"
export * from "./SaldoDeIndicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports